// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandsClappingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M20.5 2.5v-1a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 1 1-3 0Zm5.229 2.676a1.5 1.5 0 0 0 2.088-.369l.574-.818a1.5 1.5 0 0 0-2.457-1.722l-.574.82a1.5 1.5 0 0 0 .369 2.09Zm6.18 1.734a1.501 1.501 0 0 0-1.922-.898l-.94.343a1.501 1.501 0 0 0 1.026 2.82l.94-.343a1.5 1.5 0 0 0 .897-1.922Zm-3.818 4.526a10.461 10.461 0 0 1-1.564 12.573 10.5 10.5 0 0 1-19.152 2.24L3 18.673a3.75 3.75 0 0 1 2.063-5.432l-.163-.281A3.75 3.75 0 0 1 7 7.514a3.75 3.75 0 0 1 5.827-3.819 3.75 3.75 0 0 1 6 .681L19.99 6.39a3.75 3.75 0 0 1 5.736.935l2.365 4.111ZM21.82 9.572l.701 1.215c.262.25.487.536.668.85l2.375 4.113c.356.616.649 1.267.875 1.942a7.5 7.5 0 0 0-.945-4.75l-2.37-4.12a.751.751 0 1 0-1.298.75h-.006Zm-6.898-2.947.703 1.221c.262.248.486.532.666.844l1.164 2.012a3.735 3.735 0 0 1 1.15-.696L16.22 5.875a.75.75 0 1 0-1.299.75Zm-4.897.519.416.72a3.86 3.86 0 0 1 1.268-.805l-.384-.665a.75.75 0 0 0-.45-.35.75.75 0 0 0-.844 1.1h-.006Zm13.69 15.798a7.457 7.457 0 0 0-.75-5.692l-2.375-4.114a.75.75 0 0 0-1.34.671l1.416 2.443a1.5 1.5 0 1 1-2.596 1.5l-4.375-7.563a.75.75 0 0 0-1.308.738l3.078 5.325a1.499 1.499 0 1 1-2.598 1.5l-4.07-7.043a.75.75 0 1 0-1.3.75L12 19.25a1.5 1.5 0 1 1-2.599 1.5l-2.5-4.33a.75.75 0 1 0-1.299.75l4.375 7.578a7.5 7.5 0 0 0 13.739-1.808l-.001.002Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
